// 텍스트를 입력/편집할 수 있는 요소에 포커스가 가 있는지 판단한다.
// 체크박스/라디오/버튼 등은 <input>이어도 "텍스트 입력 중"이 아니므로 제외해야
// 한다 — 그렇지 않으면 체크박스를 클릭한 직후 Ctrl+C/V/Z 같은 커스텀 키보드
// 단축키가 "입력 중이니 무시"로 오판해 아무 동작도 하지 않게 된다.
const NON_TEXT_INPUT_TYPES = [
  "checkbox",
  "radio",
  "button",
  "submit",
  "reset",
  "range",
  "color",
  "file",
  "image"
];

export const isTypingContext = (
  activeElement: Element | null = document.activeElement
): boolean => {
  if (activeElement instanceof HTMLTextAreaElement) return true;
  if (activeElement instanceof HTMLElement && activeElement.isContentEditable)
    return true;
  if (activeElement instanceof HTMLInputElement)
    return !NON_TEXT_INPUT_TYPES.includes(activeElement.type);
  return false;
};
